import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DDFieldValidatorDirective } from './directives/fieldvalidator/fieldvalidator.directive';
import { ConAppTableComponent } from '../core/components/general/con-app-table/con-app-table.component';
import { DDCurrencyPricePipe } from './directives/pipes/currency-price.pipe';
import { ImageCarouselComponent } from '../core/components/general/con-image-carousel/image-carousel.component';
import { DdSlideComponent } from '../core/components/general/con-carousel/slide.component';
import { DdCarouselComponent } from '../core/components/general/con-carousel/carousel.component';
import { TwoDigitDecimaNumberDirective } from './directives/decimal/two-digit-decima-number.directive'
import { conPhonePipe } from './directives/pipes/con-phone.pipe';
import { SplitString } from './directives/pipes/split-string.pipe';
import { SafeHtmlPipe } from './directives/pipes/safe-html.pipe';
import { GridComponent } from '../feature/writeups-leads/components/grid/grid.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { PaymentSimulatorComponent } from './components/payment-simulator/payment-simulator.component';
import { CustomerInfoComponents } from './components/initiated-writeup-modal/customer-info/customer-info.component';
import { InitiatedModalComponent } from './components/initiated-writeup-modal/initiated-modal/initiated-modal.component';
import { StoreModule } from '@ngrx/store';
import { WriteupsSharedStateReducer } from './state/reducers';
import { EffectsModule } from '@ngrx/effects';
import { WriteupSharedStateEffects } from './state/effects';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ChangeCutomerAddressModalComponent } from './components/initiated-writeup-modal/change-cutomer-address-modal/change-cutomer-address-modal.component';
import { AddressModalComponent } from './components/initiated-writeup-modal/address-modal/address-modal.component';
import { FormatDisplayNamePipe } from './directives/pipes/format-display-name.pipe';

@NgModule({
  declarations: [
    DDFieldValidatorDirective,
    DDCurrencyPricePipe, 
    ConAppTableComponent,
    ImageCarouselComponent,
    DdSlideComponent,
    DdCarouselComponent,
    TwoDigitDecimaNumberDirective,
    conPhonePipe,
    SafeHtmlPipe,
    SplitString,
    FormatDisplayNamePipe,
    GridComponent,
    CustomerInfoComponents,
    AddressModalComponent,
    ChangeCutomerAddressModalComponent,
    PaymentSimulatorComponent,
    InitiatedModalComponent
  ],
  imports: [
    CommonModule,
    ScrollingModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    AutocompleteLibModule,
    StoreModule.forFeature('WriteupsSharedState', WriteupsSharedStateReducer),
    EffectsModule.forFeature(WriteupSharedStateEffects),
    NgxExtendedPdfViewerModule,
  ],
  providers:[SafeHtmlPipe],
  exports:[
    DDFieldValidatorDirective,
    DDCurrencyPricePipe, ConAppTableComponent,
    ImageCarouselComponent,
    DdSlideComponent,
    DdCarouselComponent,
    TwoDigitDecimaNumberDirective,
    conPhonePipe,
    SafeHtmlPipe,
    SplitString,
    FormatDisplayNamePipe,
    GridComponent,
    CustomerInfoComponents,
    AddressModalComponent,
    ChangeCutomerAddressModalComponent,
    PaymentSimulatorComponent,
    InitiatedModalComponent,
    NgxExtendedPdfViewerModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
